import axios from "axios";
import { auth } from "../firebase/config";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use(async (config) => {
  const fbUser = auth.currentUser;
  if (fbUser) {
    const token = await fbUser.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => Promise.reject(err)
);
